import { z } from 'zod'
import { Model } from './architecture'
import { I18nText } from './I18nText'
import { Languages } from '@s4l/i18n/types/Languages'
import { GETBannerInformationResponseType } from '../marketing/infrastructure/HTTPMarketingRepository/schemas/banners/banners-json'

export const ListOfI18nTextValidation = z.object({
  list: z.instanceof(I18nText, { message: '[ListOfI18nText] list is required' }).array(),
})

export class ListOfI18nText extends Model {
  static create({ list }: z.infer<typeof ListOfI18nTextValidation>) {
    ListOfI18nTextValidation.parse({ list })
    return new ListOfI18nText(list)
  }

  static fromDataset({
    list,
  }: {
    list: NonNullable<
      GETBannerInformationResponseType['banners'][number]['content']['all']
    >['title']
  }) {
    return ListOfI18nText.create({ list: list.map(item => I18nText.create({ value: item })) })
  }

  static fromJSON(json: ReturnType<ListOfI18nText['toJSON']>) {
    return new ListOfI18nText(json.list.map(item => I18nText.create({ value: item.value })))
  }

  constructor(private readonly _list: I18nText[]) {
    super()
  }

  get list() { return this._list } // prettier-ignore

  toJSON() {
    return { list: this._list.map(item => item.toJSON()) }
  }

  getListOfText(language?: Languages) {
    return this.list.map(item => item.getText(language))
  }
}
